import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleMobileMenuClick = (e) => {
    // Close menu when clicking on a link
    closeMobileMenu();
  };

  return (
    <>
      <header className="main-header">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <div className="navbar-brand">
              <Link to="/">
                <img src="/hellotruck-web-images/hello-truck-logo-curved.png" alt="HelloTruck" />
              </Link>
            </div>

            <div className="main-menu">
              <div className="nav-menu-wrapper">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link to="/" className="nav-link">Home</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/about" className="nav-link">About Us</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/services" className="nav-link">Services</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/attachment" className="nav-link">Attachment</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/pricing" className="nav-link">Pricing</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/blog" className="nav-link">Blog</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/contact" className="nav-link">Contact</Link>
                  </li>
                </ul>
              </div>

              <div className="header-btn">
                <a href="https://digital.hellotruck.in/login/user-login" target="_blank" rel="noopener noreferrer" className="btn-default btn-highlighted">Book your Truck</a>
              </div>
            </div>

            {/* Custom Mobile Menu Toggle */}
            <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
              <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
          </nav>

          {/* Custom Mobile Menu */}
          <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
            <div className="mobile-menu-content">
              <ul className="mobile-nav-list">
                <li>
                  <Link to="/" onClick={handleMobileMenuClick}>Home</Link>
                </li>
                <li>
                  <Link to="/about" onClick={handleMobileMenuClick}>About Us</Link>
                </li>
                <li>
                  <Link to="/services" onClick={handleMobileMenuClick}>Services</Link>
                </li>
                <li>
                  <Link to="/attachment" onClick={handleMobileMenuClick}>Attachment</Link>
                </li>
                <li>
                  <Link to="/pricing" onClick={handleMobileMenuClick}>Pricing</Link>
                </li>
                <li>
                  <Link to="/blog" onClick={handleMobileMenuClick}>Blog</Link>
                </li>
                <li>
                  <Link to="/contact" onClick={handleMobileMenuClick}>Contact</Link>
                </li>
                <li>
                  <a href="https://digital.hellotruck.in/login/user-login" target="_blank" rel="noopener noreferrer" onClick={handleMobileMenuClick} className="mobile-cta-btn">Book your Truck</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;